import React, { useEffect, useState } from "react";
import api from "../api";

const AdminMonitoringPeserta = () => {
  const apiUrl = process.env.REACT_APP_API_ENDPOINT;
  const [pesertaList, setPesertaList] = useState([]);
  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({
    event: "",
    nama: "",
    hp: "",
    email: "",
    nomorRegistrasi: "",
    sequence: ""
  });
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // Fetch peserta
  useEffect(() => {
    api.get(`${apiUrl}/api/peserta?page=${page}&size=${size}`)
      .then(res => {
        setPesertaList(res.data.content);
        setTotalPages(res.data.totalPages);
      });
    api.get(`${apiUrl}/api/events?page=0&size=100`)
      .then(res => setEvents(res.data.content));
  }, [apiUrl, page, size, showModal]);

  const openCreate = () => {
    setEditId(null);
    setForm({
      event: "",
      nama: "",
      hp: "",
      email: "",
      nomorRegistrasi: "",
      sequence: ""
    });
    setShowModal(true);
  };

  const openEdit = (peserta) => {
    setEditId(peserta.id);
    setForm({
      event: peserta.event?.id || "",
      nama: peserta.nama,
      hp: peserta.hp,
      email: peserta.email,
      nomorRegistrasi: peserta.nomorRegistrasi,
      sequence: peserta.sequence || ""
    });
    setShowModal(true);
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const payload = {
      ...form,
      event: { id: form.event }
    };
    try {
      if (editId) {
        await api.put(`${apiUrl}/api/peserta/${editId}`, payload);
      } else {
        await api.post(`${apiUrl}/api/peserta`, payload);
      }
      setShowModal(false);
    } catch (err) {
      alert("Gagal simpan data");
    }
  };

  const handleDelete = async id => {
    if (!window.confirm("Yakin hapus data ini?")) return;
    try {
      await api.delete(`${apiUrl}/api/peserta/${id}`);
      setPesertaList(pesertaList.filter(p => p.id !== id));
    } catch (err) {
      alert("Gagal hapus data");
    }
  };

  const setPageListItems = (event) => {
    const value = parseInt(event.target.getAttribute('data-value'), 10);
    setSize(value);
    setPage(0);
  };

  return (
    <div className="page-wrapper">
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Monitoring Peserta</h2>
            </div>
            <div className="col-auto ms-auto d-print-none">
              {/* <button className="btn btn-primary" onClick={openCreate}>
                Create Peserta
              </button> */}
            </div>
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container-xl">
          <div className="card">
            <div className="table-responsive">
              <table className="table card-table table-vcenter text-nowrap datatable table-hover">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Event</th>
                    <th>Nama</th>
                    <th>HP</th>
                    <th>Email</th>
                    <th>Nomor Registrasi</th>
                    {/* <th>Sequence</th> */}
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {pesertaList.length === 0 ? (
                    <tr>
                      <td colSpan={8} className="text-center">Data tidak ditemukan</td>
                    </tr>
                  ) : pesertaList.map((ps, idx) => (
                    <tr key={ps.id}>
                      <td>{page * size + idx + 1}</td>
                      <td>{ps.event?.eventCode} - {ps.event?.title}</td>
                      <td>{ps.nama}</td>
                      <td>{ps.hp}</td>
                      <td>{ps.email}</td>
                      <td>{ps.nomorRegistrasi}</td>
                      {/* <td>{ps.sequence}</td> */}
                      <td>
                        <button className="btn btn-sm btn-warning me-1" onClick={() => openEdit(ps)}>Edit</button>
                        <button className="btn btn-sm btn-danger" onClick={() => handleDelete(ps.id)}>Delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="card-footer d-flex align-items-center">
              <div className="dropdown">
                <a className="btn dropdown-toggle" data-bs-toggle="dropdown">
                  <span id="page-count" className="me-1">{size}</span>
                  <span>records</span>
                </a>
                <div className="dropdown-menu">
                  {[10, 20, 50, 100].map(val => (
                    <a className="dropdown-item" onClick={setPageListItems} data-value={val} key={val}>{val} records</a>
                  ))}
                </div>
              </div>
              <ul className="pagination m-0 ms-auto">
                <li className={`page-item${page === 0 ? ' disabled' : ''}`}>
                  <a className="page-link" href="#" tabIndex="-1" aria-disabled={page === 0}
                    onClick={e => { e.preventDefault(); if (page > 0) setPage(page - 1); }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                      viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                      className="icon icon-1">
                      <path d="M15 6l-6 6l6 6" />
                    </svg>
                    prev
                  </a>
                </li>
                {[...Array(totalPages)].map((_, idx) => (
                  <li key={idx} className={`page-item${page === idx ? ' active' : ''}`}>
                    <a className="page-link" href="#" onClick={e => { e.preventDefault(); setPage(idx); }}>{idx + 1}</a>
                  </li>
                ))}
                <li className={`page-item${page === totalPages - 1 ? ' disabled' : ''}`}>
                  <a className="page-link" href="#" aria-disabled={page === totalPages - 1}
                    onClick={e => { e.preventDefault(); if (page < totalPages - 1) setPage(page + 1); }}>
                    next
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                      viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                      className="icon icon-1">
                      <path d="M9 6l6 6l-6 6" />
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.3)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">{editId ? 'Edit Peserta' : 'Create Peserta'}</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Event</label>
                    <select className="form-select" name="event" value={form.event} onChange={handleChange} required>
                      <option value="">Pilih Event</option>
                      {events.map(ev => (
                        <option key={ev.id} value={ev.id}>{ev.eventCode} - {ev.title}</option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Nama</label>
                    <input type="text" className="form-control" name="nama" value={form.nama} onChange={handleChange} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">HP</label>
                    <input type="text" className="form-control" name="hp" value={form.hp} onChange={handleChange} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input type="email" className="form-control" name="email" value={form.email} onChange={handleChange} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Nomor Registrasi</label>
                    <input type="text" className="form-control" name="nomorRegistrasi" value={form.nomorRegistrasi} onChange={handleChange} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Sequence</label>
                    <input type="number" className="form-control" name="sequence" value={form.sequence} onChange={handleChange} />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">{editId ? 'Update' : 'Create'}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminMonitoringPeserta;